import type { AppSession } from '@app/icare/client/auth'

export interface CurrentUser {
  id?: string
  username?: string
  firstName?: string | null
  lastName?: string | null
  roles?: string[]
}

export const deriveCurrentUser = (session?: AppSession): CurrentUser | undefined => {
  if (!session?.user) return undefined
  const s = session.session
  const roles = s && typeof s === 'object' && 'roles' in s && Array.isArray(s.roles) ? (s.roles as string[]) : []
  return {
    id: session.user.id,
    username: session.user.name,
    firstName: 'firstName' in session.user ? (session.user.firstName as string | null) : undefined,
    lastName: 'lastName' in session.user ? (session.user.lastName as string | null) : undefined,
    roles,
  }
}
